const Empty: React.FC = () => <></>;

export default Empty;
